import { useEffect, useRef } from 'react';
import { useAppDispatch } from 'redux/store-hooks';
import { clientAppSelectors, getAllClients } from 'redux/slices/clientSlice';
import { actingUserAppSelectors } from 'redux/slices/actingUserSlice';
import {
  getAllInternalNumbers,
  internalPhoneNumbersSelectors,
} from 'redux/slices/internalPhoneNumberSlice';
import { getTeamsAsAdmin } from 'redux/slices/teamsSlice';
import { getNeedsMetadata, metaSliceSelectors } from 'redux/slices/metaSlice';
import {
  getMessageTemplates,
  messageTemplatesSelectors,
} from 'redux/slices/messageTemplatesSlice';

export const useAdminDashboardData = () => {
  const dispatch = useAppDispatch();
  const hasInitialized = useRef(false);

  const actingUser = actingUserAppSelectors.useSelectActingUser();
  const allClients = clientAppSelectors.useSelectAllClients();
  const defaultInternalNumbers =
    internalPhoneNumbersSelectors.useSelectAllDefaultInternalNumbers();
  const messageTemplates = messageTemplatesSelectors.useSelectAll();
  const needsMetadata = metaSliceSelectors.useSelectNeedsMetadata();

  useEffect(() => {
    if (hasInitialized.current) return;

    dispatch(getAllClients({ params: { includeConsents: true } }));
    dispatch(getTeamsAsAdmin({}));
    dispatch(getAllInternalNumbers({}));
    dispatch(getMessageTemplates({}));
    dispatch(getNeedsMetadata({}));

    hasInitialized.current = true;
  }, [dispatch]);

  return {
    actingUser,
    allClients,
    defaultInternalNumbers,
    messageTemplates,
    needsMetadata,
  };
};
